import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useRoute } from "wouter";

import {
  DealerPartNumberResultsRoute,
  DealerVehicleResultsRoute,
} from "../../../navigation/DealerRoutes";
import { VehicleHeader } from "../../VehicleHeader/VehicleHeader";
import { TireList } from "./TireList";
import { TireStatusbar } from "./TireStatusbar";

export const Tires: FunctionComponent = () => {
  const [isVehicle] = useRoute(DealerVehicleResultsRoute);
  const [isPartNumber] = useRoute(DealerPartNumberResultsRoute);
  return (
    <>
      <VehicleHeader className="mt-10 mx-4 lg:mx-0" />
      {!isPartNumber && (
        <TireStatusbar className={clsx(isVehicle ? "md:mt-0" : "mt-4")} />
      )}
      <TireList />
    </>
  );
};
